// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../assets/fonts/Gartner_Sans_Variable_Romans.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../assets/fonts/Gartner_Sans_Variable_Romans.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../assets/fonts/Gartner_Sans_Variable_Italics.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../../assets/fonts/Gartner_Sans_Variable_Italics.woff", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  height: 100%;
  display: flex;
  flex-direction: column;
  margin: 0;
  padding: 0;
}

pre {
  background: lightgrey;
  padding: 20px;
}

p a {
  color: #4330ff;
}
p a:hover {
  color: #282829;
}

@font-face {
  font-family: "GartnerSansVar";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff2");
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff");
  font-weight: 300 800;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "GartnerSansVar";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2");
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff");
  font-weight: 300 800;
  font-style: italic;
  font-display: swap;
}
#root {
  font-family: "GartnerSansVar", sans-serif;
}

.submit-button {
  display: inline-block;
  border-radius: 5px;
  font-weight: 400;
  text-align: center;
  vertical-align: middle;
  margin: 0 20px 20px 20px;
  height: 40px;
  min-width: 120px;
  width: calc(50% - 2px);
  color: #fff;
  background-color: #4330ff;
  border-width: 1px;
}
.submit-button:hover {
  color: #eaeaea;
  cursor: pointer;
}

.cancel-button {
  display: inline-block;
  font-weight: 400;
  text-align: center;
  vertical-align: middle;
  background: #f2f2f2;
  margin: 0 20px 20px 20px;
  height: 40px;
  min-width: 120px;
  width: calc(50% - 2px);
  border-radius: 5px;
  color: #4330ff;
}
.cancel-button:hover {
  color: black;
  cursor: pointer;
}

.solar-button {
  background-color: #fa504b !important;
  color: white !important;
}`, "",{"version":3,"sources":["webpack://./src/components/VirtualPortal/css/index.scss","webpack://./src/app/variables.scss"],"names":[],"mappings":"AACA;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,UAAA;AAAF;;AAGA;EACE,qBAAA;EACA,aAAA;AAAF;;AAGA;EACE,cCWY;ADXd;AACE;EACE,cCOK;ADNT;;AAGA;EACE,6BAAA;EACA,4DAAA;EACA,2DAAA;EACA,oBAAA;EACA,kBAAA;EACA,kBAAA;AAAF;AAGA;EACE,6BAAA;EACA,4DAAA;EACA,2DAAA;EACA,oBAAA;EACA,kBAAA;EACA,kBAAA;AADF;AAIA;EACE,yCAAA;AAFF;;AAKA;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,wBAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;EACA,WAAA;EACA,yBC5BY;ED6BZ,iBAAA;AAFF;AAGE;EACE,cAAA;EACA,eAAA;AADJ;;AAKA;EACE,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,mBC1Dc;ED2Dd,wBAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;EACA,kBAAA;EACA,cC/CY;AD6Cd;AAGE;EACE,YAAA;EACA,eAAA;AADJ;;AAKA;EACE,oCAAA;EACD,uBAAA;AAFD","sourcesContent":["@import '../../../app/variables.scss';\nbody {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  margin: 0;\n  padding: 0;\n}\n\npre {\n  background: lightgrey;\n  padding: 20px;\n}\n\np a {\n  color: $evanta-blue;\n  &:hover {\n    color: $eblack;\n  }\n}\n\n@font-face {\n  font-family: 'GartnerSansVar';\n  src: url('../../../assets/fonts/Gartner_Sans_Variable_Romans.woff2') format('woff2');\n  src: url('../../../assets/fonts/Gartner_Sans_Variable_Romans.woff') format('woff');\n  font-weight: 300 800;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'GartnerSansVar';\n  src: url('../../../assets/fonts/Gartner_Sans_Variable_Italics.woff2') format('woff2');\n  src: url('../../../assets/fonts/Gartner_Sans_Variable_Italics.woff') format('woff');\n  font-weight: 300 800;\n  font-style: italic;\n  font-display: swap;\n}\n\n#root {\n  font-family: 'GartnerSansVar', sans-serif;\n}\n\n.submit-button{\n  display: inline-block;\n  border-radius: 5px;\n  font-weight: 400;\n  text-align: center;\n  vertical-align: middle;\n  margin: 0 20px 20px 20px;\n  height: 40px;\n  min-width: 120px;\n  width: calc(50% - 2px);\n  color: #fff;\n  background-color: $evanta-blue;\n  border-width: 1px;\n  &:hover {\n    color: #eaeaea;\n    cursor: pointer;\n  }\n}\n\n.cancel-button {\n  display: inline-block;\n  font-weight: 400;\n  text-align: center;\n  vertical-align: middle;\n  background: $lightest-gray;\n  margin: 0 20px 20px 20px;\n  height: 40px;\n  min-width: 120px;\n  width: calc(50% - 2px);\n  border-radius: 5px;\n  color: $evanta-blue;\n  &:hover {\n    color: black;\n    cursor: pointer;\n  }\n}\n\n.solar-button {\n  background-color: $solar !important;\n\tcolor: white !important;\n}\n//\n// input:checked + .slider {\n//   background-color: $active-slider;\n// }\n","// Font colors\n$success-color: #38bb15;\n$warning-color: #feb52b;\n$error-color: #ff2e2e;\n$link-color: #428bca;\n\n$blue: #2d7cbf;\n$blue-light-gray: #d4e4e9;\n\n$lightest-gray: #f2f2f2;\n$light-gray: #eaeaea;\n$medium-lightest-gray: #dcdcdc;\n$medium-light-gray: #909092;\n$medium-gray: #c0c0c0;\n$medium-dark-gray: #606060;\n$dark-gray: #404040;\n\n$teal: #32c3b5;\n$gold: #f2b130;\n\n$light-base: #006AC7;\n$light-active: #264A82;\n$success-base: #00A76D;\n\n$eblack: #282829;\n$egrey: #dcddde;\n$evanta-blue: #4330ff;\n$evanta-blue-secondary: #5c4ee5;\n$gartner-blue: #002869;\n$active-slider: #3fe85c;\n$solar: #fa504b;\n$solar-secondary: #fb736f;\n$solar-tertiary: #DE0A01;\n\n\n// Font sizes\n$biggest-header: 36px;\n$big-header: 28px;\n$larger: 20px;\n$large: 16px;\n$medium: 14px;\n$small: 13px;\n$smaller: 12px;\n$tiny: 11px;\n\n// Homepage colors\n// $goldLight: #F9D889;\n// $goldPrimary: #F4B213;\n// $goldDark: #92451C;\n// $greenLight: #CDE3A5;\n// $greenPrimary: #9CC84B;\n// $greenDark: #416428;\n// $mintLight: #95E1DA;\n// $mintPrimary: #2BC4B6;\n// $mintDark: #00566B;\n// $purpleLight: #C6B1D4;\n// $purplePrimary: #8D64AA;\n// $purpleDark: #46295B;\n\n$goldLight: #F9D783;\n$goldPrimary: #92451C;\n$goldDark: #F5B51D;\n$greenLight: #C7E09A;\n$greenPrimary: #416428;\n$greenDark: #A0CA51;\n$mintLight: #8EDFD8;\n$mintPrimary: #02576C;\n$mintDark: #33C7B9;\n$purpleLight: #C3ADD2;\n$purplePrimary: #513465;\n$purpleDark: #9068AD;\n\n\n// virtual portal colors\n$vp-dark-gray: #6D6E71;\n$vp-black: #2C2C2C;\n$vp-bright-red: #FA504B;\n$vp-dark-gray-50op: rgba(109, 110, 113, 0.5)\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
